import React, { Component } from "react";
import { connect } from "react-redux";
import { list } from "../actions";
import AdminList from "./AdminList";
import InvalidAccessView from "./InvalidAccessView";

class Admins extends Component {
  componentDidMount() {
    this.props.fetchAdmins();
    this.handleTableAction = this.handleTableAction.bind(this);
  }

  handleTableAction(eventName, data) {
    this[eventName](data);
  }

  changeAdminPassword(admin) {
    this.props.history.push(`/admins/${admin.id}/password`);
  }

  editAdmin(admin) {
    this.props.history.push(`/admins/${admin.id}/edit`);
  }

  userNotAllowed() {
    const allowedRoles = ["super_admin"];
    return !allowedRoles.includes(this.props.currentUserRole);
  }

  render() {
    if (this.userNotAllowed()) {
      return <InvalidAccessView />;
    }

    return (
      <AdminList
        handleEvent={this.handleTableAction}
        admins={this.props.admins}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    admins: state.admins.list,
    currentUserRole: state.app.role
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAdmins() {
      dispatch(list("admins"));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admins);



// WEBPACK FOOTER //
// ./src/components/Admins.js